import styled, { css } from 'styled-components';

interface CardStatusProp {
  status: string;
}

export const Container = styled.li`
  position: relative;
  min-height: 33.7rem;
  background: #fff;
  border-radius: 4px;

  padding: 1.8rem 2.6rem;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const CardContainer = styled.div`
  cursor: pointer;
`;

export const CardLine = styled.div`
  display: flex;
  margin-bottom: 1rem;
`;

export const CardLineLabel = styled.p`
  font-weight: 600;
  padding-right: 3px;
`;

export const CardLineValue = styled.span`
  font-weight: 500;
`;

export const CardStatus = styled.div<CardStatusProp>`
  height: 4.4rem;

  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 279px;
  }

  @media (max-width: 425px) {
    width: 100%;
  }

  ${(props) =>
    props.status === 'Pendente' &&
    css`
      background: #ffd503;
    `}

  ${(props) =>
    props.status === 'Paga' &&
    css`
      background: #04c230;
      color: #fff;
    `}

  ${(props) =>
    props.status === 'Vencida' &&
    css`
      background: #d90606;
      color: #fff;
    `}

  ${(props) =>
    props.status === 'Cancelada' &&
    css`
      background: #e2e2e2;
    `}
`;

export const CardStatusWrapper = styled.div`
  display: flex;
`;

export const CardStatusLabel = styled.label`
  font-weight: 600;
  font-size: 1.7rem;
  padding-right: 3px;
`;

export const CardStatusValue = styled.span`
  font-size: 1.7rem;
  font-weight: 500;
`;

export const Options = styled.div`
  position: absolute;
  right: 3%;
  top: 5%;

  cursor: pointer;

  > svg {
    &:hover {
      background: #dadada;
      border-radius: 50%;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;

    position: absolute;
    left: -10rem;
    overflow: hidden;

    width: 14rem;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;
    pointer-events: none;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    button,
    a {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      &:hover {
        background: #40404030;
      }
    }

    a {
      color: #d90606;
    }
  }

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;
